/* istanbul ignore file */
import { Show } from 'framework/show';
import { ShowSection, SectionRow, ShowPageLayout } from 'framework/ui/layout';
import useLedgerService from 'domain/finance/ledger/useLedgerService';
import LedgerHeader from 'domain/finance/ledger/shared/LedgerHeader';
import CreateJournalEntryWithParamsButton from 'domain/finance/journalEntry/shared/button/CreateJournalEntryWithParamsButton';
import SingleLedgerBreadcrumbs from 'domain/finance/ledger/shared/SingleLedgerBreadcrumbs';
import { useLedgerId } from 'domain/finance/ledger/shared/useLedgerId';
import LedgerTransfersList from 'domain/finance/ledger/shared/field/LedgerTransfersList';
import BalanceField from 'domain/finance/ledger/shared/field/BalanceField';

const LedgerViewPage = () => {
  const accountId = useLedgerId().replace(/[_]/g, '/');
  const { getById } = useLedgerService();

  return (
    <Show getDataMethod={() => getById(accountId)}>
      <ShowPageLayout
        entityHeader={<LedgerHeader />}
        breadcrumbs={<SingleLedgerBreadcrumbs />}
        headerButtons={[<CreateJournalEntryWithParamsButton />]}
        hasSeparateSections
      >
        <ShowSection>
          <SectionRow colMd={2} colXl={4}>
            <BalanceField label="Balance" source="balance" nameSource="name" isShownOneValue />
          </SectionRow>
        </ShowSection>

        <ShowSection>
          <LedgerTransfersList title="Transfers" filter={{ accountsIds: [accountId], includeTransfers: true }} />
        </ShowSection>
      </ShowPageLayout>
    </Show>
  );
};

export default LedgerViewPage;
